(function () {
  var q = window.matchMedia('(max-width: 820px)');
  var was = q.matches;
  function trim() {
    var drop = q.matches ? 'desktop' : 'mobile';
    [].forEach.call(document.querySelectorAll('.dn-hv-media [data-dn-media="' + drop + '"]'), function (n) {
      var v = n.querySelector('video');
      if (v) { v.pause(); }
      n.parentNode.removeChild(n);
    });
  }
  trim();
  function changed() {
    if (q.matches !== was && !(window.Shopify && window.Shopify.designMode)) {
      window.location.reload();
    }
  }
  if (q.addEventListener) q.addEventListener('change', changed);
  document.addEventListener('shopify:section:load', trim);
})();
